<template>
  <div class="planning-default">
    <div class="row" style="display: flex; justify-items: center; align-items: center">
      <div class="col-12 col-md-3 text-center text-sm-start">
        <page-title v-if="formattedPlanning" :title="this.$moment(date).format('dd D MMM')" icon="planning"></page-title>
        <page-title v-else title="Geen planning" icon="planning"></page-title>
      </div>
      <div class="col-12 col-md-5" style="text-align: left">
        <div class="row">
          <div
            v-if="getApplicationSetting('ipad_real_time_bkr') === '0'"
            class="col-6 col-sm-3"
            style="padding: 0"
          >
            <span  v-if="totalChildrenPresent > 0" class="badge bg-green">
              {{ totalChildrenPresent }}
            </span>
            <span v-else class="badge">
              {{ totalChildrenPresent }}
            </span>
            <span class="d-inline d-sm-block d-md-inline">
              aanwezig
            </span>
          </div>
          <div v-if="getApplicationSetting('ipad_care') === '1'" class="col-6 col-sm-3" style="padding: 0">
            <span v-on:click="showModalCare = true">
              <span v-if="totalChildrenCare > 0" class="badge bg-red">
                {{ totalChildrenCare }}
              </span>
              <span v-else class="badge">
                {{ totalChildrenCare }}
              </span>
              <span class="d-inline d-sm-block d-md-inline">
                verzorging
              </span>
            </span>
          </div>
          <div v-if="getApplicationSetting('ipad_transfer_notes') === '1'" class="col-6 col-sm-3" style="padding: 0">
            <span v-on:click="openTransferNotesDialog('nonSticky')">
              <span v-if="totalTransferNotesWithDate > 0" class="badge bg-red">
                {{ totalTransferNotesWithDate }}
              </span>
              <span v-else class="badge">
                {{ totalTransferNotesWithDate }}
              </span>
              <span class="d-inline d-sm-block d-md-inline">
                overdracht
              </span>
            </span>
          </div>
          <div v-if="getApplicationSetting('ipad_announcements') === '1'" class="col-6 col-sm-3" style="padding: 0">
            <span v-on:click="openTransferNotesDialog('sticky')">
              <span v-if="totalTransferNotesWithoutDate > 0" class="badge bg-red">
                {{ totalTransferNotesWithoutDate }}
              </span>
              <span v-else class="badge">
                {{ totalTransferNotesWithoutDate }}
              </span>
              <span class="d-inline d-sm-block d-md-inline">
                mededel.
              </span>
            </span>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4 text-center text-md-end" style="padding-bottom: 0">
        <button
            v-if="showMutationsOnly === true"
            class="btn btn-secondary me-1"
            @click="showMutationsOnly = !showMutationsOnly"
        >
            <i class="fa-solid fa-calendar-circle-exclamation"></i>
        </button>
        <button
            v-else
            class="btn btn-secondary me-1"
            @click="showMutationsOnly = !showMutationsOnly"
        >
            <i class="fa-light fa-calendar-circle-exclamation"></i>
        </button>
        <date-range-select :listenToDate="this.$moment(date).format('YYYY-MM-DD')" type="day" @changeDateRange="setDate($event.dateStart)" :emitOnCreated="false"></date-range-select>
        <date-picker class="ms-1" :listenToDate="this.$moment(date).format('YYYY-MM-DD')" @setDate="setDate($event)" type="button" />
      </div>
    </div>
    <div v-if="isLoading" class="row">
      <div class="col-12 text-center">
        <p>
          Laden...
        </p>
      </div>
   </div>
    <div v-else-if="formattedPlanning && formattedPlanning.length > 0 && children && children.length > 0">
      <span v-if="formattedPlanning && formattedPlanning.length > 0">
        <div v-if="getApplicationSetting('ipad_child_employee_ratio') === '1'" class="row" style="margin-bottom: 2px;">
          <div class="col-sm-3">
              <div
                v-if="getApplicationSetting('ipad_real_time_bkr') === '1'"
                style="padding-left: 7px;"
              >
                <div>
                  <span  v-if="totalChildrenPresent > 0" class="badge bg-green">
                    {{ totalChildrenPresent }}
                  </span>
                  <span v-else class="badge">
                    {{ totalChildrenPresent }}
                  </span>
                  <span class="d-inline d-sm-block d-md-inline">
                    kinderen aanwezig
                  </span>
                </div>
                <div>
                  <span  v-if="employeesNeeded > 0" class="badge">
                    {{ employeesNeeded }}
                  </span>
                  <span v-else class="badge">
                    0
                  </span>
                  <span class="d-inline d-sm-block d-md-inline">
                    medewerkers nodig
                  </span>
                </div>
              </div>
          </div>
          <div class="col-12 col-sm-9" style="text-align: left" v-on:click="showModalRatio = true">
            <child-ratio-bar :date="this.$moment(date).format('YYYY-MM-DD')" :data="planningRatio" :minStartTime="this.startTime" :maxEndTime="this.endTime" />
          </div>
        </div>
      </span>
      <div class="row" style="margin-bottom: 10px">
        <div class="col-sm-3">
        </div>
        <div class="col-12 col-sm-9 p-0 d-flex">
          <div class="d-inline-block" v-for="time in timeLineHours" v-bind:key="time" :style="{width: hourPercentage + '%'}">{{ time }}</div>
        </div>
      </div>
      <span v-for="child in formattedPlanning" v-bind:key="child.id_child">
        <div v-if="getChild(child.id_child) || filter.length < 1" class="row" style="background: rgba(255, 255, 255, 255); margin-bottom: 10px">
          <div class="col-12 col-sm-3" style="display: flex; flex-direction: column; justify-content: center;">
            <div class="row" style="display: flex; justify-items: center; align-items: center">
              <div class="col-3 col-sm-7 col-md-6 col-lg-5 col-xl-4 d-flex align-items-center" style=" margin-top: 5px;">
                <child-thumbnail :key="child.id_child" :child="getChild(child.id_child) || child" @click-handler="togglePresence(child)" :height="'100%'" style="margin: auto; vertical-align: middle"></child-thumbnail>
              </div>
              <div class="col-9 col-sm-5 col-md-6 col-lg-7 col-xl-8" style="margin-top: 5px;">
                <div style="display: flex; justify-items: center; align-items: center">
                  <router-link :to="'/children/' + child.id_child">
                    <div style="font-weight: 200; font-size: 20px; color: #3D415C">
                      {{ getChild(child.id_child).first_name }}
                      {{ getChild(child.id_child).last_name_suffix }}
                      {{ getChild(child.id_child).last_name }}
                    </div>
                    <div style="color: #A4AEC1">
                      {{ getAge(getChild(child.id_child).date_of_birth, false) }}
                    </div>
                    <div style="color: #A4AEC1">
                      {{ getChild(child.id_child).school ? getChild(child.id_child).school.name : '' }}
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-9 p-0 d-flex align-items-center position-relative">
            <template v-if="child.planning.length > 0">
              <template v-for="item in timeToBlocks(child.planning)" v-bind:key="item.startTime">
                <div
                  v-if="item.color === true"
                  :style="getStyle(item)"
                  v-on:click="getApplicationSetting('ipad_planning_row_edit') === '1' ? showModalPlanningAction(child.id_child, getCurrentGroup(getChild(child.id_child)), (typeof date !== 'string' ? date.format('YYYY-MM-DD') : date)) : null"
                  :title="item.text"
                >
                  <div>{{ item.text }}</div>
                  <div style="font-size: 11px;" v-if="selectedGroups.length > 1">{{item.group.name}}</div>
                </div>
                <div v-else>
                  <!-- nothing -->
                </div>
              </template>
            </template>
          </div>
        </div>
      </span>
    </div>
    <div v-else class="row">
      <div class="col-12 text-center">
        <p>
          Geen planning
        </p>
      </div>
    </div>

    <CareOverviewModal
        v-if="showModalCare"
        :childIds="childrenCareUniqueIdChilds"
        @onClose="showModalCare = false"
    />

    <TransferNotesListModal
        v-if="showModalTransferNotes"
        :date="date"
        :transferNotesType="transferNotesType"
        @onClose="showModalTransferNotes = false"
    />

    <modal v-if="showModalPlanning">
      <template v-slot:header>
        <h3 class="modal-title">{{modalTitle}}</h3>
        <button v-on:click="closeModalPlanningAction()">
          <span class="btn-close">
            <span aria-hidden="true">&times;</span>
          </span>
        </button>
      </template>
      <template v-slot:body>
        <div id="calendarDialog" class="dialog-child-planning" style="padding: 20px">
          <agenda-dialog
              :idChild="modalSelect.idChild"
              :idGroup="modalSelect.idGroup"
              :date="modalSelect.date"
              :agendaDialogsessionToken="session.session_token"
              :agendaDialogDeviceToken="deviceToken"
              :agendaDialogApi="apiUrl"
              :agendaDialogApiV3="apiUrlV3"
              @agenda-dialog-child-ill="illChanged"
          />
        </div>
      </template>
      <template v-slot:footer>
        <div>
          <button
              type="button"
              class="btn btn-outline-info"
              v-on:click="closeModalPlanningAction()"
          >Sluiten</button>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import DateRangeSelect from '@/components/Date-Range-Select'
import DatePicker from '@/components/Date-Picker'
import PageTitle from '@/components/Page-Title'
import ChildThumbnail from '@/components/Child-Thumbnail'
import ChildRatioBar from '@/components/Child-Ratio-Bar'
import Modal from '@/components/Modal'
import "@novict/kidsadmin-agenda-dialog/dist/kidsadmin-agenda-dialog.css"
import AgendaDialog from "@novict/kidsadmin-agenda-dialog"
import CareOverviewModal from '@/modals/CareOverviewModal'
import TransferNotesListModal from '@/modals/TransferNotesListModal'
export default {
  name: 'planning-detailed-default',
  components: {
    DateRangeSelect,
    DatePicker,
    PageTitle,
    ChildThumbnail,
    ChildRatioBar,
    Modal,
    AgendaDialog,
    CareOverviewModal,
    TransferNotesListModal
  },
  computed: {
    planning () {
      return this.$store.getters.planning
    },
    planningRatio () {
      return this.$store.getters.planningRatio || []
    },
    filter () {
      return this.$store.getters.globalChildByIdFilter
    },
    transferNotes () {
      return this.$store.getters.transferNotes
    },
    deviceToken () {
      return this.$store.getters.deviceToken
    },
    session () {
      return this.$store.getters.session
    },
    selectedGroup () {
      return this.$store.getters.selectedGroup
    },
    groupInstructions () {
      return this.$store.getters.groupInstructions
    }
  },
  data () {
    return {
      employeesNeeded: null,
      date: null,
      addNewTransferNote: false,
      showModalCare: false,
      showModalTransferNotes: false,
      totalChildrenPresent: 0,
      totalChildrenCare: 0,
      totalTransferNotesWithDate: 0,
      totalTransferNotesWithoutDate: 0,
      dialogTransferNotes: [],
      care: null,
      showModalPlanning: false,
      modalTitle: "",
      modalSelect: {
        idChild: 0,
        idGroup: 0,
        date: '',
      },
      apiUrl: process.env.VUE_APP_API_URL,
      apiUrlV3: process.env.VUE_APP_API_V3_URL,
      showMutationsOnly: false,
      formattedPlanning: [],
      childrenCareUniqueIdChilds: [],
      startTime: null,
      endTime: null,
      hourPercentage: null,
      timeLineHours: [],
    }
  },
  watch: {
    planning: {
      handler () {
        this.updatePlanning()
      },
      deep: true
    },
    children: {
      handler () {
        this.setTotalChildrenCare()
        this.setTotalChildrenPresent()
        this.updatePlanning()
      },
      deep: true
    },
    transferNotes: {
      handler () {
        this.setTotalTransferNotes()
        this.setTotalAnnouncements()
      },
      deep: true
    },
    groupInstructions: {
      handler () {
        this.setTotalTransferNotes()
        this.setTotalAnnouncements()
      },
      deep: true
    },
    showMutationsOnly () {
      this.updatePlanning()
    }
  },
  created () {
    this.$store.dispatch('getChildren')

    let planDate = this.$moment().format('YYYY-MM-DD');
    if (this.$store.getters.datePlanning !== null) {
       planDate = this.$moment(this.$store.getters.datePlanning).format('YYYY-MM-DD')
    } else {
      if (this.planning && this.planning.date) {
        planDate = this.$moment(this.planning.date).format('YYYY-MM-DD')
      }
    }

    this.setDate(planDate)
    this.setTotalChildrenPresent()
    this.setTotalChildrenCare()
    this.setTotalTransferNotes()
    this.setTotalAnnouncements()

    window.novict = {
      apiBaseUrl: process.env.VUE_APP_API_URL,
      device: {
        device_token: this.deviceToken
      },
      session: {
        session_token: this.session.session_token
      }
    }
  },
  methods: {
    updateEmployeesNeeded () {
      if (this.getApplicationSetting('ipad_real_time_bkr') === '0') {
        return
      }
      this.employeesNeeded = null
      this.getBkr(this.date).then((response) => {
        if (response.data.employees_needed) {
          this.employeesNeeded = response.data.employees_needed
        }
      })
    },
    updatePlanning () {
      var rawPlanning = this.$store.getters.planning
      var planningPerChild = {}
      var childIdsNotInLocalStorage = []
      var startTime = null;
      var endTime = null;
      if (rawPlanning && rawPlanning.length > 0) {
        for (var i = 0; i < rawPlanning.length; i++) {
          var planItem = rawPlanning[i]

          if (startTime === null || planItem.start_time < startTime) {
              startTime = planItem.start_time;
          }

          if (endTime === null || planItem.end_time > endTime) {
            endTime = planItem.end_time;
          }

          if (endTime === '00:00:00') {
            endTime = '23:59:59'
          }

          if (
              this.showMutationsOnly === true
              &&
              rawPlanning[i].status
              &&
              rawPlanning[i].status === 'DEFAULT'
          ) {
            continue;
          }
          if (this.getChildShouldBeVisibleById(planItem.child.id) === false) {
            continue
          }
          if (!Object.prototype.hasOwnProperty.call(planningPerChild, planItem.child.id)) {
            planningPerChild[planItem.child.id] = {
              id_child: planItem.child.id,
              planning: []
            }
          }
          planningPerChild[planItem.child.id].planning.push(planItem)
          if (this.getChild(planItem.child.id) === false) {
            childIdsNotInLocalStorage.push(planItem.child.id)
          }
        }
        if (childIdsNotInLocalStorage.length > 0) {
          this.appendChildrenById(childIdsNotInLocalStorage)
        }
        this.startTime = this.$moment('2022-01-01 ' + startTime).startOf('hour').format('HH:mm:ss')
        const m = this.$moment('2022-01-01 ' + endTime);

        if (m.minute()) {
          m.add(1, 'hours')
        }
        endTime = m.startOf('hour').format('HH:mm:ss')
        if (endTime === '00:00:00') {
          endTime = '23:59:59'
        }
        this.endTime = endTime
        const startTimeInt = parseInt(this.startTime.substr(0,2))
        let endTimeInt = parseInt(this.endTime.substr(0,2))
        // fix for care until 23:30 for example, see ticket #58092
        if (parseInt(this.endTime.substr(3,2)) > 0) {
          endTimeInt++
        }
        // fix for child care until 00:00, see ticket #57469
        if (endTimeInt === 0) {
          endTimeInt = 24
        }

        this.hourPercentage = 100 / (endTimeInt - startTimeInt)

        this.timeLineHours = [];
        for (let i = startTimeInt; i < endTimeInt; i++) {
          this.timeLineHours.push(i);
        }
      }
      planningPerChild = Object.values(planningPerChild)
      planningPerChild = this.sortArrayByChildOrder(planningPerChild, 'id_child')
      this.setIsLoading(false)

      this.formattedPlanning = planningPerChild
      this.setTotalChildrenCare()
      this.setTotalChildrenPresent()
    },
    closeModalPlanningAction() {
      this.showModalPlanning = false
      this.modalTitle = ''
      this.setDate(this.date)
    },
    showModalPlanningAction(idChild, idGroup, date) {
      this.showModalPlanning = true;
      this.modalSelect = {
        idChild: idChild,
        idGroup: idGroup,
        date: date,
      },
      this.$request.post(process.env.VUE_APP_API_URL + "/ChildPlanning/gettitle", {
          ...this.$request.getDeprecatedBodyAuthentication(),
          idChild: idChild,
          date: date
        })
        .then(data => {
          this.modalTitle = "Planning " +
              data.child.name +
              " op " +
              this.$moment(data.date).format("DD-MM-YYYY");
        });
    },
    setIsLoading (bool) {
      this.isLoading = bool
    },
    openTransferNotesDialog(transferNotesType) {
      this.showModalTransferNotes = true
      this.transferNotesType = transferNotesType;
    },
    startNewTransferNote () {
      this.addNewTransferNote = true
    },
    onDialogAddShow () {
      this.addNewTransferNote = false
    },
    getTitleTransferNotes() {
      if (this.transferNotesType === 'sticky') {
        return 'Mededeling'
      } else {
        return 'Overdracht'
      }
    },
    sort (children, by) {
      by = by || this.getApplicationSetting('ipad_sort_children_by')
      if (by === false) {
        by = 'first_name'
      }
      return this.$lodash().sortBy(children, [child => child[by].toLowerCase()], 'asc')
    },
    setDate (date) {
      this.date = date
      this.setIsLoading(true)
      this.$store.dispatch('getPlanning', this.$moment(date).format('YYYY-MM-DD'))
      this.$store.dispatch('getChildrenPresence')
      this.$store.dispatch('getTransferNotes', {date: this.$moment(date).format('YYYY-MM-DD')})
      this.$store.dispatch('getGroupInstructions')
      this.$store.dispatch('updateDatePlanning', date)
    },
    setTotalChildrenPresent () {
      let total = 0
      let presentChildren = this.getChildrenPresent()
      total = presentChildren.length || 0
      if (this.totalChildrenPresent !== total) {
        this.updateEmployeesNeeded()
        this.totalChildrenPresent = total
      }

    },
    setTotalChildrenCare () {
      var total = 0
      if (this.planning) {
        this.childrenCareUniqueIdChilds = []
        var presentChildren = this.planning
        for (var i = 0; i < presentChildren.length; i++) {
          if (this.getItemsFilteredByChild({id: presentChildren[i].child.id}, this.groupInstructions).length > 0) {
            if (this.childrenCareUniqueIdChilds.includes(presentChildren[i].child.id) === false) {
              this.childrenCareUniqueIdChilds.push(presentChildren[i].child.id)
              total++
            }
          }
        }
      }
      this.totalChildrenCare = total
    },
    setTotalTransferNotes () {
      var total = 0
      if (this.transferNotes) {
        for (var i = 0; i < this.transferNotes.length; i++) {
          if (this.transferNotes[i].sticky === false && this.transferNotes[i].date === this.date) {
            total++
          }
        }
      }
      this.totalTransferNotesWithDate = total
    },
    setTotalAnnouncements () {
      var total = 0
      if (this.transferNotes) {
        for (var i = 0; i < this.transferNotes.length; i++) {
          if (this.transferNotes[i].sticky === true) {
            total++
          }
        }
      }
      this.totalTransferNotesWithoutDate = total
    },
    getChildrenPresent () {
      var app = this
      return this.$lodash().filter(this.children, function (child) {
        return app.getChildIsPresent(child)
      })
    },
    childInPlanning (child) {
      var inPlanning = false
      if (this.planning && this.planning.length > 0) {
        this.planning.forEach(element => {
          if (element.id_child === child.id) {
            inPlanning = true
          }
        })
      }
      return inPlanning
    },
    timeToBlocks (scheduleBlocks) {
      var blocks = []
      const dayStartTime = this.$moment('2022-01-01 ' + this.startTime)
      if (scheduleBlocks) {
        for (var i = 0; i < scheduleBlocks.length; i++) {
          const startTime = this.$moment('2022-01-01 ' + scheduleBlocks[i].start_time)
          const endTime = this.$moment('2022-01-01 ' + scheduleBlocks[i].end_time)
          blocks.push({
            color: true,
            startTime: startTime.format('HH:mm'),
            endTime: endTime.format('HH:mm'),
            status: scheduleBlocks[i].status || null,
            group: scheduleBlocks[i].group || null,
            hours: endTime.diff(startTime, 'hours', true),
            hoursFromStartTime: startTime.diff(dayStartTime, 'hours', true),
            text: startTime.format('HH:mm') + ' - ' + endTime.format('HH:mm')
          })
        }
      }
      return blocks
    },
    togglePresence (child) {
      child = this.getChild(child.id_child) || child
      if (this.getChildIsPresent(child) === true) {
        // becomes false
        var presence = this.getChildPresence(child)
        this.$request.put('/presence/' + presence.id, {}
        ).then((response) => {
          if (response.data && response.data.id) {
            this.setChildPresent(child, response.data)
            this.setTotalChildrenPresent()
          }
        })
      } else if (this.getChildIsPresent(child) === false) {
        // becomes true
        var currentGroupId = this.getCurrentGroup(child)
        if (currentGroupId === null) {
          alert('Kon de groep van het kind niet bepalen')
        }
        this.$request.post('/presence', {
          child_id: child.id,
          group_id: currentGroupId
        }).then((response) => {
          if (response.data && response.data.id) {
            this.setChildPresent(child, response.data)
            this.setTotalChildrenPresent()
          }
        })
      }
    },
    selectChild (child) {
      var id = null
      if (child.id_child) {
        id = child.id_child
      }
      if (child.id) {
        id = child.id_child = child.id
      }
      if (id !== null) {
        this.$store.commit('SET_SELECTED_CHILD', this.getChild(id))
      }
    },
    getStyle (planningItem) {
      var backgroundColor = '#8e70d3'
      var borderColor = '#765cae'
      if (planningItem.status && planningItem.status === 'DELETED') {
        backgroundColor = 'rgb(150,150,150)'
        borderColor = 'rgb(125,125,125)'
      }


      return {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        marginTop: '5px',
        marginBottom: '5px',
        height: '44px',
        background: backgroundColor,
        border: '2px solid ' + borderColor,
        borderRadius: '20px',
        color: 'white',
        textAlign: 'center',
        cursor: 'pointer',
        marginLeft: (this.hourPercentage * planningItem.hoursFromStartTime) + '%',
        width: 'calc(' + (this.hourPercentage * planningItem.hours) + '%)',
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap",
      }
    },
    illChanged(event) {
      this.appendChildrenById([event.idChild])
    }
  }
}
</script>

<style scoped>
  a {
    color: #666;
  }
  .badge {
    min-width: 20px;
    font-size: 12px;
    line-height: 11px;
    padding: 5px 0 7px;
    vertical-align: top;
    margin-top: 2px;
    padding: 6px;
    padding-left: 8px;
    padding-right: 8px;
    padding-bottom: 7px;
    border-radius: 16px;
    background: #bcc6d3;
  }
  .bg-green {
    background:rgb(72, 200, 141) !important;
  }
  .bg-red {
    background:rgb(255, 89, 79) !important
  }
  .status-20,
  .status-danger {
    background: rgb(255, 89, 79) !important;
  }
  .status-10,
  .status-success {
    background: rgb(72, 200, 141) !important;
  }
  .status-30,
  .status-warning {
    background: #EFBA1C !important;
  }
  /*.close-25 {
    font-size: 2.5rem;
  }*/
</style>
